const link_list = {
    routePath: 'exinterests',
    actionName: 'count',
    iconClass: 'fas fa-meh-rolling-eyes',
    title: 'My Intent To Submit',
    search: {
        status: {
            key: 'status',
            value: ['Active'],
        },
    },
    sort: {
        order: 'asc',
        column: 'date_entered',
    },
    perPage: '',
}
export default { link_list }